import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <main data-testid="not-found" className="bg-white text-[#111] min-h-[80vh] flex items-center">
      <Helmet><title>Page not found | MODULAROOM</title></Helmet>
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-40">
        <div className="text-[11px] tracking-[0.32em] uppercase text-black/50">404</div>
        <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight leading-[0.98]">This space isn’t built yet.</h1>
        <Link to="/" className="mt-10 inline-block rounded-full bg-[#111] text-white px-7 py-4 text-[13px] tracking-[0.2em] uppercase hover:bg-[#C7A36A] transition-colors">Return home</Link>
      </div>
    </main>
  );
}
